import React from 'react'
import { css } from '@emotion/react'
import { string, bool } from 'prop-types'
import { Button } from '@livechat/design-system-react-components'

const btnCss = css`
  min-width: 120px;
`

const LoadingButton = ({ size, className, fullWidth }) => {
  return (
    <Button
      css={btnCss}
      data-test="loading-btn"
      loading
      kind="primary"
      size={size}
      className={className}
      fullWidth={fullWidth}
      children="loading..."
    />
  )
}

LoadingButton.propTypes = {
  size: string,
  className: string,
  fullWidth: bool,
}

export default LoadingButton
